import { ShieldAlert } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

const TIP = "Privacy notice not yet sent. Email sending is off until a Resend key is added";

export const ConsentBadge = ({ consent, testId = "consent-pending-badge" }) => {
  if (!consent?.privacy_notice_pending) return null;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button type="button" onClick={(e) => e.stopPropagation()} aria-label={`Consent pending. ${TIP}`} data-testid={testId}
          className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-[#E8D7B0] bg-caution-tint px-2 py-0.5 text-[11px] font-medium text-caution">
          <ShieldAlert size={12} aria-hidden="true" /> Consent pending <span aria-hidden="true" className="opacity-70">ⓘ</span>
        </button>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs bg-ink text-white leading-relaxed">{TIP}</TooltipContent>
    </Tooltip>
  );
};
